
import React from 'react';

interface AstraLogoProps {
  className?: string;
  size?: number;
}

const AstraLogo: React.FC<AstraLogoProps> = ({ className = "", size = 40 }) => {
  return (
    <div className={`relative group ${className}`} style={{ width: size, height: size }}>
      <svg
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full drop-shadow-[0_0_12px_rgba(0,209,255,0.6)]"
      >
        <defs>
          <linearGradient id="shieldLeft" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#0072b1" />
            <stop offset="100%" stopColor="#003d5c" />
          </linearGradient>
          <linearGradient id="shieldRight" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#00b4ff" />
            <stop offset="100%" stopColor="#006699" />
          </linearGradient>
          <linearGradient id="starSilver" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#f8fafc" />
            <stop offset="50%" stopColor="#94a3b8" />
            <stop offset="100%" stopColor="#cbd5e1" />
          </linearGradient>
          <filter id="glow-logo">
            <feGaussianBlur stdDeviation="1.5" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {/* Shield - Right Half (Lighter) */}
        <path
          d="M50 5 C50 5 85 8 90 12 V65 C90 85 50 95 50 95 V5Z"
          fill="url(#shieldRight)"
        />
        {/* Shield - Left Half (Darker) */}
        <path
          d="M50 5 C50 5 15 8 10 12 V65 C10 85 50 95 50 95 V5Z"
          fill="url(#shieldLeft)"
        />

        {/* Circuit Pattern - Left */}
        <g stroke="#00d1ff" strokeWidth="0.8" opacity="0.8">
          <path d="M15 40 H2 L-5 40" />
          <circle cx="-5" cy="40" r="1.5" fill="#00d1ff" />
          <path d="M12 45 H0 L-8 45" />
          <circle cx="-8" cy="45" r="1.5" fill="#00d1ff" />
          <path d="M12 50 H0 L-8 50" />
          <circle cx="-8" cy="50" r="1.5" fill="#00d1ff" />
          <path d="M15 55 H2 L-5 55" />
          <circle cx="-5" cy="55" r="1.5" fill="#00d1ff" />
        </g>

        {/* Circuit Pattern - Right */}
        <g stroke="#00d1ff" strokeWidth="0.8" opacity="0.8">
          <path d="M85 40 H98 L105 40" />
          <circle cx="105" cy="40" r="1.5" fill="#00d1ff" />
          <path d="M88 45 H100 L108 45" />
          <circle cx="108" cy="45" r="1.5" fill="#00d1ff" />
          <path d="M88 50 H100 L108 50" />
          <circle cx="108" cy="50" r="1.5" fill="#00d1ff" />
          <path d="M85 55 H98 L105 55" />
          <circle cx="105" cy="55" r="1.5" fill="#00d1ff" />
        </g>

        {/* Silver Star of David (Interlocked Triangles) */}
        <g filter="url(#glow-logo)">
          {/* Triangle 1 */}
          <path
            d="M50 20 L78 68 L22 68 Z"
            stroke="url(#starSilver)"
            strokeWidth="3.5"
            strokeLinejoin="round"
            fill="none"
          />
          {/* Triangle 2 */}
          <path
            d="M50 80 L22 32 L78 32 Z"
            stroke="url(#starSilver)"
            strokeWidth="3.5"
            strokeLinejoin="round"
            fill="none"
          />
        </g>

        {/* Center SA Monogram */}
        <path
          d="M42 52 Q42 46 48 46 H54 Q60 46 60 52 V54 Q60 60 54 60 H48 Q42 60 42 54"
          stroke="#02040a"
          strokeWidth="1.5"
          fill="none"
          opacity="0.3"
        />
        <text
          x="50"
          y="54"
          fill="url(#starSilver)"
          fontSize="10"
          fontWeight="900"
          textAnchor="middle"
          dominantBaseline="middle"
          style={{ fontFamily: 'JetBrains Mono, monospace', letterSpacing: '-1px' }}
        >
          SA
        </text>

        {/* Decorative Internal Nodes */}
        <circle cx="22" cy="22" r="1.5" fill="white" opacity="0.6" />
        <circle cx="78" cy="22" r="1.5" fill="white" opacity="0.6" />
      </svg>
    </div>
  );
};

export default AstraLogo;
